import LandingPage from '@/components/LandingPage.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import LeaderboardPage from '@/components/LeaderboardPage.vue';
import ManageProfile from '@/components/ManageProfile.vue';
import { isAuthenticated } from '@/utils/auth';

const pageRoutes = [{
    path: '/',
    component: LandingPage,
    meta: {
        title: "Akademi Siber | We Born Hackers"
    },
    // Logged-in users skip the marketing landing and go straight to their dashboard
    beforeEnter: (to, from, next) => {
        next(isAuthenticated() ? '/dashboard' : true);
    },
},
{
    path: '/dashboard',
    component: DashboardPage,
    meta: {
        requiresAuth: true,
        title: "Dashboard | Akademi Siber"
    },
},
{
    path: '/profile',
    component: ManageProfile,
    meta: {
        requiresAuth: true,
        title: "Manage Profile | Akademi Siber"
    },
},
{
    path: '/leaderboard',
    component: LeaderboardPage,
    meta: {
        requiresAuth: false, // Allow public access to scoreboard
        title: "Leaderboard | Akademi Siber"
    },
}
];

export default pageRoutes;
